export const BASE_QUERY_KEY = "opportunity-list";
